import Colors from 'assets/Colors';
import Lang from 'assets/Lang';
import Styles from 'assets/Styles';
import Funcs from 'common/helpers/Funcs';
import UIConst from 'consts/UIConst';
import React from 'react';
import { Animated, StyleSheet, TouchableOpacity, View } from 'react-native';
import AntDesign from 'react-native-vector-icons/AntDesign';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import ThemeContextView from 'states/context/views/ThemeContextView';
import KeyboardHandle from '../views/KeyboardHandleView';
import BaseButton from './BaseButton';
import BaseText from './BaseText';

interface Config {
  title: string;
  detail: string;
  placeholder: string;
  callback: () => void;
  autoClose: boolean;
}

export default class BaseStaticModal extends ThemeContextView<Config> {
  static instance = new Map();

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      config: {}
    };
    this.heightMove = new Animated.Value(0);
    this.styles = styles;
    BaseStaticModal.instance.set(this.constructor, this);
    this.contentWidth = UIConst.MAX_WIDTH;
    this.contentStyle = {};
  }

  static show(config: Config = {}) {
    const scope = this.getScope();
    if (!scope) return Funcs.log(`${this.name} instance not exist`);
    // useNativeDriver:false để Fabric không lệch native props với TextInput
    scope.heightMove.setValue(0);
    scope.setState({ visible: true, config }, scope.moveUp);
  }

  static hide() {
    const scope = this.getScope();
    if (!scope) return Funcs.log(`${this.name} instance not exist`);
    scope.moveDown();
  }

  static update(config) {
    const scope = this.getScope();
    if (!scope) return Funcs.log(`${this.name} instance not exist`);
    scope.reset();
    scope.setState({ config });
  }

  static getScope() {
    return BaseStaticModal.instance.get(this);
  }

  reset = () => {};

  moveUp = () => {
    Animated.timing(this.heightMove, {
      toValue: 1,
      duration: 250,
      useNativeDriver: false
    }).start();
  };

  moveDown = () => {
    Animated.timing(this.heightMove, {
      toValue: 0,
      duration: 200,
      useNativeDriver: false
    }).start(() => {
      this.setState({ visible: false });
    });
  };

  onPressOk = () => this.moveDown();

  onPressCancel = () => this.moveDown();

  renderContent = () => {
    return null;
  };

  renderBottomButton = () => {
    return (
      <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: UIConst.SCALE * 10 }}>
        <BaseButton style={{ ...styles.bottomButton, backgroundColor: 'gray' }} onPress={this.onPressCancel}>
          <AntDesign name={'closecircle'} color={'white'} size={UIConst.SCALE * 14} />
          <BaseText numberOfLines={1} adjustsFontSizeToFit style={{ marginLeft: UIConst.SCALE * 3, color: 'white' }}>
            {Lang.cancel}
          </BaseText>
        </BaseButton>
        <BaseButton style={{ ...styles.bottomButton, backgroundColor: Colors.colorApp }} onPress={this.onPressOk}>
          <MaterialCommunityIcons name={'content-save'} color={'white'} size={UIConst.SCALE * 15} />
          <BaseText numberOfLines={1} adjustsFontSizeToFit style={{ marginLeft: UIConst.SCALE * 3, color: 'white' }}>
            {Lang.ok}
          </BaseText>
        </BaseButton>
      </View>
    );
  };

  render() {
    let { visible, config = {} } = this.state;
    if (!visible) return null;
    const translate = this.heightMove.interpolate({
      inputRange: [0, 1],
      outputRange: [UIConst.HEIGHT, 0]
    });
    const { autoClose = true } = config;

    return (
      <KeyboardHandle style={styles.container}>
        <TouchableOpacity activeOpacity={1} style={Styles.modal} onPress={this.moveDown} disabled={!autoClose} />
        <Animated.View style={[{ transform: [{ translateY: translate }] }]}>
          <View
            style={[
              styles.container1,
              { width: this.contentWidth ? this.contentWidth : UIConst.MAX_WIDTH, borderColor: Colors.border, backgroundColor: Colors.background, shadowColor: Colors.shadow },
              this.contentStyle
            ]}>
            {this.renderContent()}
          </View>
        </Animated.View>
      </KeyboardHandle>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    justifyContent: 'center',
    alignItems: 'center'
  },
  container1: {
    ...Styles.shadow,

    borderRadius: UIConst.SCALE * 15,
    padding: UIConst.SCALE * 10
  },
  button: {
    ...Styles.center,
    borderWidth: 1,
    borderColor: Colors.border,
    padding: UIConst.SCALE * 10,
    paddingHorizontal: UIConst.SCALE * 15,
    borderRadius: UIConst.SCALE * 5
  },
  buttonMarginLeft: {
    ...Styles.center,
    borderWidth: 1,
    borderColor: Colors.border,
    padding: UIConst.SCALE * 10,
    paddingHorizontal: UIConst.SCALE * 15,
    marginLeft: UIConst.SCALE * 10,
    borderRadius: UIConst.SCALE * 5
  },
  bottomButton: {
    ...Styles.center,
    borderRadius: UIConst.SCALE * 6,
    paddingHorizontal: UIConst.SCALE * 12,
    paddingVertical: UIConst.SCALE * 8,
    marginHorizontal: UIConst.SCALE * 5,
    flexDirection: 'row'
  }
});
